import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'

const endpoint = 'org-monitoring'
const Actions = crudActions(endpoint)

const createOrUpdate = (ctx, orgMonitoring) => new Promise((resolve, reject) => {
  const formData = new FormData()
  formData.append('quarter', orgMonitoring.quarter)
  if (orgMonitoring.file_upload instanceof File) formData.append('file', orgMonitoring.file_upload)
  const isUpdateRequest = orgMonitoring.id ? `${orgMonitoring.id}/` : ''
  axios[orgMonitoring.id ? 'patch' : 'post'](`/${endpoint}/${isUpdateRequest}`, formData)
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
export default {
  ...Actions,
  createOrUpdate,
}
